import React from "react";
import { TextInput } from "react-materialize";
import Html from "./Html";
import { Dropdown } from "semantic-ui-react";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CheckedRequired(filters) {
    const elems = document.querySelectorAll('[data-required="true"]');
    const n = elems.length;
    let checked = true;
    for (let i = 0; i < n; i++) {
      //if (!checked) continue;
      const name = elems[i].getAttribute("name");
      const multiple = elems[i].getAttribute("multiple");
      //console.log(name, filters);
      if (name === "employment_type") {
        if (
          filters?.employment &&
          filters?.employment.length > 0 &&
          filters?.employment?.[0].employment_type !== ""
        ) {
          continue;
        } else {
          checked = false;
        }
      } else if (name === "start_date") {
        if (
          filters?.employment &&
          filters?.employment.length > 0 &&
          filters?.employment?.[0].start_date !== ""
        ) {
          continue;
        } else {
          checked = false;
        }
      } else if (filters?.[name] === undefined) {
        checked = false;
      } else if (
        multiple !== null &&
        filters?.[name] &&
        filters?.[name].length === 0
      ) {
        checked = false;
      } else if (filters[name] === "") {
        checked = false;
      }
    }
    return checked;
  },
  MultiSelect: function ({ data, filters, events }) {
    let keyId = data?.keyId ?? 0;
    let defaultValue = data?.defaultValue ?? [];
    if (defaultValue.length === 0 && filters?.[data.name]) {
      defaultValue = filters[data.name];
    }
    const required = data?.required ?? false;
    if (events === undefined) {
      events = {};
    }
    if (!("OnChange" in events)) {
      events.OnChange = () => {};
    }
    let label = "";
    if ("label" in data) {
      label = (
        <label htmlFor={data?.id ?? ""} className="label">
          {data.label}
        </label>
      );
    }
    return (
      <div
        key={"filter-" + data.name + "-" + keyId}
        className={
          "filter-input-field select" +
          (data?.addClass ? " " + data.addClass : "")
        }
      >
        {label}
        <Dropdown
          fluid
          selection
          multiple={true}
          search={true}
          id={data?.id ?? ""}
          name={data.name}
          options={Html.OptionList(data.options, {
            id: data?.id ?? "",
            key: data.name,
            name: data?.optionName ?? "name",
            value: data?.optionValue ?? "value",
            optionGroup: data?.optionGroup ?? false,
            title: data?.optionTitle ?? "",
            optionNull: data?.optionNull ?? false,
          })}
          value={defaultValue}
          onChange={events.OnSelectChange}
          //onSearchChange={this.handleSearchChange}
          disabled={data?.disabled ?? false}
          data-required={required}
          style={{ width: "95%" }}
        />
        <span
          className={
            "select-helper-text" +
            (required && defaultValue.length === 0 ? "" : " hide")
          }
          id={"helper-text-" + data.name}
        >
          {"Please select " + (data?.label ?? data.name)}
        </span>
      </div>
    );
  },
  SingleSelect: function ({ data, filters, events }) {
    let keyId = filters?.key_form ?? 0;
    let defaultValue = data?.defaultValue ?? "";
    if (defaultValue === "" && filters?.[data.name]) {
      defaultValue = filters[data.name] + "";
    }
    const required = data?.required ?? false;
    if (events === undefined) {
      events = {};
    }
    if (!("OnChange" in events)) {
      events.OnChange = () => {};
    }
    let label = "";
    if ("label" in data) {
      label = (
        <label htmlFor={data?.id ?? ""} className="label">
          {data.label}
        </label>
      );
    }
    let style = { width: "95%" };
    if (data?.style) {
      style = data.style;
    }
    return (
      <div
        key={"filter-" + data.name + "-" + keyId}
        className={
          "filter-input-field select" +
          (data?.addClass ? " " + data.addClass : "")
        }
        style={data?.addStyle ?? {}}
      >
        {label}
        <Dropdown
          fluid
          selection
          multiple={false}
          search={true}
          id={data?.id ?? ""}
          name={data.name}
          options={Html.OptionList(data.options, {
            id: data?.id ?? "",
            key: data.name,
            name: data?.optionName ?? "name",
            value: data?.optionValue ?? "value",
            optionGroup: data?.optionGroup ?? false,
            title: data?.optionTitle ?? "",
            optionNull: data?.optionNull ?? false,
          })}
          value={defaultValue}
          onChange={events.OnSelectChange}
          //onSearchChange={this.handleSearchChange}
          disabled={data?.disabled ?? false}
          data-required={required}
          style={style}
        />
        <span
          className={
            "select-helper-text" +
            (required && defaultValue === "" ? "" : " hide")
          }
          id={"helper-text-" + data.name}
        >
          {"Please select " + (data?.label ?? data.name)}
        </span>
      </div>
    );
  },
  InputDate: function ({ data, filters, events }) {
    let keyId = data?.keyId ?? 0;
    const type = data?.type ?? "date";
    let defaultValue = data?.defaultValue ?? "";
    if (defaultValue === "" && filters?.[data.name]) {
      defaultValue = filters[data.name];
    }
    const required = data?.required ?? false;
    if (events === undefined) {
      events = {};
    }
    if (!("OnChange" in events)) {
      events.OnChange = () => {};
    }
    return (
      <div
        key={"input-" + data.name + "-" + keyId}
        className={
          "filter-input-field" + (data?.addClass ? " " + data.addClass : "")
        }
      >
        <label htmlFor={data?.id ?? ""} className="label">
          {data.label}
        </label>
        <TextInput
          //icon={<Icon>search</Icon>}
          placeholder=""
          id={data?.id ?? ""}
          name={data.name}
          type={type}
          defaultValue={defaultValue}
          onChange={events.OnChange}
          data-required={required}
          disabled={data?.disabled ?? false}
        />
        <span
          className={
            "select-helper-text input" +
            (required && defaultValue === "" ? "" : " hide")
          }
          id={"helper-text-" + data.name}
        >
          {"Please select " + (data?.label ?? data.name)}
        </span>
      </div>
    );
  },
  InputText: function ({ data, filters, events }) {
    let keyId = data?.keyId ?? 0;
    let value = data?.value ? data.value + "" : "";
    if (value === "" && data?.defaultValue) {
      value = data.defaultValue;
    }
    if (value === "" && filters?.[data.name]) {
      value = filters[data.name] + "";
    }
    if (data?.defaultValue === undefined && data?.value === undefined) {
      data.defaultValue = value;
    }
    const required = data?.required ?? false;
    if (events === undefined) {
      events = {};
    }
    if (!("OnChange" in events)) {
      events.OnChange = () => {};
    }
    return (
      <div
        key={"input-" + data.name + "-" + keyId}
        className={
          "filter-input-field" + (data?.addClass ? " " + data.addClass : "")
        }
        style={data?.input?.style}
      >
        {data?.label ? (
          <label htmlFor={data?.id ?? ""} className="label">
            {data.label}
          </label>
        ) : (
          ""
        )}
        <TextInput
          //icon={<Icon>search</Icon>}
          placeholder=""
          id={data?.id ?? ""}
          name={data.name}
          onChange={events.OnChange}
          data-required={required}
          disabled={data?.disabled ?? false}
          {...(data?.value !== undefined ? { value: value + "" } : {})}
          {...(data?.defaultValue !== undefined ? { value: value + "" } : {})}
        />
        <span
          className={
            "select-helper-text input" +
            (required && value === "" ? "" : " hide")
          }
          id={"helper-text-" + data.name}
        >
          {"Please select " + (data?.label ?? data.name)}
        </span>
      </div>
    );
  },
};
